/**
 * Deleting the transcript from asset by revisionId
 * @param {Object} assets,
 * @param {Object} payload,
 * @param {string} payload.assetId
 * @param {string} payload.revisionId
 * @returns {Array}
 */
export default function deleteTranscript(assets, payload) {
  const {
    assetId, revisionId,
  } = payload;

  const updatedAssets = assets.map((asset) => {
    if (asset._id === assetId) {
      const updatedTranscripts = asset.transcripts.filter((currentTranscript) => currentTranscript.revisionId !== revisionId);

      return {
        ...asset,
        transcripts: updatedTranscripts,
      };
    }
    return asset;
  });

  return updatedAssets;
}
